import {Mapper} from '@s-ui/domain'

const DEFAULT_PAGE = 1

export class FromSearchParamsToRequestVOMapper extends Mapper {
  constructor({config, searchRequestValueObject}) {
    super()
    this._config = config
    this._searchRequestValueObject = searchRequestValueObject
    this._defaultSearch = this._config.get('search').DEFAULT_SEARCH
    this._technicalDetailsSearchPageName = this._config.get('page').TECHNICAL_DETAILS_SEARCH_PAGE_NAME
    this._technicalDetailsSearchResultsPageName = this._config.get('page').TECHNICAL_DETAILS_SEARCH_RESULTS_PAGE_NAME
    this._professionalStockPageName = this._config.get('page').PROFESSIONAL_STOCK_PAGE_NAME
    this._dealersListPageName = this._config.get('page').DEALERS_LIST_PAGE_NAME
    this._defaultTechnicalDetailsSearch = this._config.get('technicalDetails').DEFAULT_SEARCH
    this._sortFields = this._config.get('SORT_FIELDS')
    this._sortQueryParams = this._config.get('SORT_QUERY_PARAM')
    this._sortOrderOptions = this._config.get('ORDER')
  }

  _getSortOrder = ({or}) => {
    let parsedOrder = or

    const isStringOrder = Object.values(this._sortOrderOptions).includes(or)

    if (isStringOrder) {
      parsedOrder = or === this._sortOrderOptions.ASC ? 1 : -1
    }

    return Number(parsedOrder) === 1 ? this._sortOrderOptions.ASC : this._sortOrderOptions.DESC
  }

  _getSortBy({context, fi}) {
    const isTechnicalDetailsSearchPage =
      context === this._technicalDetailsSearchPageName || context === this._technicalDetailsSearchResultsPageName

    const isDealersListPage = context === this._dealersListPageName

    if (!fi) {
      return isTechnicalDetailsSearchPage ? this._sortFields.TITLE : this._sortFields.RELEVANCE
    }

    if (isDealersListPage) return fi

    const sortQueryParams = Object.entries(this._sortQueryParams)
    const selectedSortField = sortQueryParams.find(sort => {
      const {1: param} = sort
      return param.toLowerCase() === fi.toLowerCase()
    })

    return selectedSortField ? selectedSortField[0] : fi
  }

  _getNotDefault = item => item !== ''

  _getFuelTypeIds = ({FuelTypeId}) => (FuelTypeId ? FuelTypeId?.split(',').filter(this._getNotDefault) : undefined)

  _getBodyTypeIds = ({BodyTypeId}) => (BodyTypeId ? BodyTypeId?.split(',').filter(this._getNotDefault) : undefined)

  _getEquipments = ({Equipments}) => (Equipments ? Equipments?.split(',').filter(this._getNotDefault) : undefined)

  _getDoors = ({Doors}) => (Doors ? [Doors].filter(this._getNotDefault) : undefined)

  map = ({query, context}) => {
    const {
      cityId,
      fi,
      MakeId: makeId,
      MaxHp: maxHp,
      MaxKms: maxKms,
      MaxLitres: maxLitres,
      MaxPrice: maxPrice,
      MaxYear: maxYear,
      MinHp: minHp,
      MinKms: minKms,
      MinLitres: minLitres,
      MinPrice: minPrice,
      MinYear: minYear,
      Model: model,
      ModelId: modelId,
      ModelVersionId: modelVersionId,
      or,
      pg,
      province,
      provinceId,
      Section2,
      size,
      Version: version
    } = query

    const hasModel = Boolean(model) || Boolean(modelId)
    const hasPrice = Boolean(minPrice) || Boolean(maxPrice)
    const hasLitres = Boolean(minLitres) || Boolean(maxLitres)
    const hasKms = Boolean(minKms) || Boolean(maxKms)
    const hasYear = Boolean(minYear) || Boolean(maxYear)
    const hasHp = Boolean(minHp) || Boolean(maxHp)

    const isProfessionalStockContext = context === this._professionalStockPageName

    const isDealersListContext = context === this._dealersListPageName

    const categoryId = isProfessionalStockContext || isDealersListContext ? undefined : this._defaultSearch.categoryId

    const category2Id = Section2 ? Number(Section2) : undefined

    return this._searchRequestValueObject({
      context,
      categoryId,
      category2Id,
      cityId,
      page: Number(pg) || DEFAULT_PAGE,
      sortBy: this._getSortBy({context, fi}),
      sortOrder: this._getSortOrder({or}),
      makeId,
      ...(hasModel && {model: {id: modelId, name: model}}),
      modelVersionId,
      equipments: this._getEquipments(query),
      fuelTypeIds: this._getFuelTypeIds(query),
      bodyTypeIds: this._getBodyTypeIds(query),
      ...(hasPrice && {
        price: {
          from: minPrice,
          to: maxPrice
        }
      }),
      ...(hasLitres && {
        litres: {
          from: minLitres,
          to: maxLitres
        }
      }),
      ...(hasKms && {
        kms: {
          from: minKms,
          to: maxKms
        }
      }),
      ...(hasYear && {
        year: {
          from: minYear,
          to: maxYear
        }
      }),
      version,
      doors: this._getDoors(query),
      ...(hasHp && {
        hp: {
          from: minHp,
          to: maxHp
        }
      }),
      province,
      provinceId,
      size
    })
  }
}
